import { Link } from "react-router-dom";
// icons
import { IoClose } from "react-icons/io5";
// components
import Qty from "../components/Qty";
import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { formatPrice } from "../lib/formatPrice";

export default function CartItem({ item }) {
  const { removeFromCart } = useContext(CartContext);
  return (
    <div className="flex gap-x-8">
      <Link to={`/product/${item.slug}`} className="w-[70px] h-[70px]">
        <img src={`${item.image}`} alt={item.title} loading="lazy" />
      </Link>
      <div className="flex-1">
        <div className="flex gap-x-4 mb-3">
          <Link to={`/product/${item.slug}`} className="hover:text-brand transition-colors">
            {item.title}
          </Link>
          <button
            type="button"
            onClick={() => removeFromCart(item._id)}
            aria-label={`Remove ${item.title} from cart`}
            className="cursor-pointer text-[24px] text-muted hover:text-danger transition-colors">
            <IoClose />
          </button>
        </div>
        <div className="flex items-center gap-x-12">
          <div className="flex gap-x-4 mb-2">
            <Qty item={item} />
          </div>
          <div className="text-ink font-semibold text-xl">
            {formatPrice(item.regularPrice * item.amount)}
          </div>
        </div>
        <div>
          <span className="text-muted">{formatPrice(item.regularPrice)} per piece</span>
        </div>
      </div>
    </div>
  );
}
